// step 1 of the sponsor pledge flow
import React from 'react'
import { Trans } from 'react-i18next'

import Icon from '../../../../components/icon'
import { formatAmount } from '../../../../lib/numbers'

export default function Step1Commitment({
  styles,
  t,
  minPledge,
  meetsMin,
  commitmentNum,
  commitmentInput,
  setCommitmentInput,
  spinCommitment,
  onEnterStep2,
  civillosOpen,
  setCivillosOpen,
}) {
  return (
    <>
      <h1 className={styles.stepHeading}>
        {t('sponsorPledgeFlow.step1.heading')}
      </h1>
      <p className={styles.stepSubheading}>
        <Trans
          i18nKey="sponsorPledgeFlow.step1.subheading"
          values={{ min: formatAmount(minPledge, true) }}
        />
      </p>

      <div className={styles.tierCard}>
        <div className={styles.tierCardName}>
          {t('sponsorPledgeFlow.tier.name')}
          <span className={styles.exclBadge}>
            {t('sponsorPledgeFlow.tier.badge')}
          </span>
        </div>
        <p className={styles.tierCardDesc}>
          {t('sponsorPledgeFlow.tier.description')}
        </p>
        <div className={styles.tierPerks}>
          {[1, 2, 3, 4].map(i => (
            <div key={i} className={styles.tierPerk}>
              <Icon name="check" className={styles.tierPerkIcon} />
              <span>{t(`sponsorPledgeFlow.tier.perk${i}`)}</span>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.civillosAcc}>
        <button
          type="button"
          className={styles.civillosAccHead}
          onClick={() => setCivillosOpen(o => !o)}
        >
          <span>{t('sponsorPledgeFlow.civillosAccordion.title')}</span>
          <Icon name={civillosOpen ? 'chevron-up' : 'chevron-down'} />
        </button>
        {civillosOpen ? (
          <div className={styles.civillosAccBody}>
            {t('sponsorPledgeFlow.civillosAccordion.body')}
          </div>
        ) : null}
      </div>

      <div className={styles.sectionLabel} style={{ marginTop: 0 }}>
        {t('sponsorPledgeFlow.step1.pledgeLabel')}
        <span className={styles.crRequired}>*</span>
      </div>
      <p className={styles.stepSubheading} style={{ marginTop: 0 }}>
        {t('sponsorPledgeFlow.step1.pledgeHint')}
      </p>

      <div
        className={[
          styles.amountWrap,
          meetsMin ? styles.amountWrapValid : '',
          commitmentNum > 0 && !meetsMin ? styles.amountWrapInvalid : '',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <span className={styles.amountCurrency}>$</span>
        <input
          className={styles.amountInput}
          type="text"
          inputMode="numeric"
          value={commitmentInput}
          onChange={e =>
            setCommitmentInput(e.target.value.replace(/[^\d]/g, ''))
          }
          placeholder={String(minPledge || 1000)}
          aria-label={t('sponsorPledgeFlow.step1.pledgeLabel')}
        />
        <div className={styles.amountSpinners}>
          <button
            type="button"
            className={styles.amountSpinnerBtn}
            onClick={() => spinCommitment(50)}
          >
            <Icon name="chevron-up" />
          </button>
          <button
            type="button"
            className={styles.amountSpinnerBtn}
            onClick={() => spinCommitment(-50)}
          >
            <Icon name="chevron-down" />
          </button>
        </div>
      </div>
      {commitmentNum > 0 && !meetsMin ? (
        <div className={styles.errorMsg}>
          {t('sponsorPledgeFlow.step1.minError', {
            min: formatAmount(minPledge, true),
          })}
        </div>
      ) : null}

      <div className={styles.infoNote}>
        <Icon name="info-circle" />
        <span>{t('sponsorPledgeFlow.step1.infoNote')}</span>
      </div>

      <div className={styles.stepNav}>
        <div />
        <button
          type="button"
          className={styles.btnPrimary}
          disabled={!meetsMin}
          onClick={onEnterStep2}
        >
          {t('sponsorPledgeFlow.step1.cta')}
          <Icon name="chevron-right" />
        </button>
      </div>
    </>
  )
}
